import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { BankAccount, BankAccountService, BankConnection, ToastService } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';
import { plainToClass } from 'class-transformer';

/**
 * Component contain manual bank account form or import basiq bank accounts form depending on bank connection
 */
@Component({
  selector: 'app-bank-accounts-add',
  templateUrl: './bank-accounts-add.component.html',
  styleUrls: ['./bank-accounts-add.component.scss'],
  standalone: false
})
export class BankAccountsAddComponent extends BaseComponent implements OnInit {
  @Input() connection: BankConnection;
  @Output() saved: EventEmitter<BankAccount[]> = new EventEmitter();
  @Output() back: EventEmitter<void> = new EventEmitter();
  @Output() connectionSaved: EventEmitter<BankConnection> = new EventEmitter();

  bankAccount: BankAccount;

  private bankAccountService = inject(BankAccountService);
  private toastService = inject(ToastService);

  ngOnInit(): void {
    this.bankAccount = plainToClass(BankAccount, { bankConnection: this.connection });
  }

  save(bankAccounts: BankAccount[]): void {
    this.bankAccountService.postBatch(bankAccounts).subscribe((newBankAccounts: BankAccount[]) => {
      const notification = this.connection.isBasiq()
        ? 'We will notify you once available transactions have been imported (this usually takes a few minutes).'
        : 'You can import your bank transactions from CSV file.';
      this.toastService.success(notification);
      this.saved.emit(newBankAccounts);
    });
  }
}
